import React from "react";

function Tags({ data, action, currentFilter, element }) {
  const handleSlide = (element, direction, speed, distance, step) => {
    let filter = document.querySelector(`.${element}`);
    let scrollAmount = 0;
    const slideTimer = setInterval(function () {
      if (direction === "left") {
        filter.scrollLeft -= step;
      } else {
        filter.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  };

  return (
    <section className="section__tags-filter">
      <button
        className="tags__filter--btn-slide btn--back"
        onClick={() => handleSlide(element, "left", 15, 500, 15)}
        aria-label="Фильтры назад"
      >
        <i className="fal fa-chevron-left"></i>
      </button>
      <div className={`tags__filter--wrapper ${element}`}>
        <button
          className={
            currentFilter === "all" ? "filter-btn filter-active" : "filter-btn"
          }
          data-filter="all"
          onClick={() => action("", "Все")}
        >
          Все
        </button>
        {!data ? null : (
          <>
            {data
              .filter((element) => element.isPriorityFilter)
              .map(({ topicForFilters, topic }) => (
                <button
                  className={
                    currentFilter === topicForFilters
                      ? "filter-btn filter-active"
                      : "filter-btn"
                  }
                  key={topic}
                  data-filter={topicForFilters}
                  onClick={() => action(topicForFilters, topic)}
                >
                  {topic}
                </button>
              ))}
            {data
              .filter((element) => !element.isPriorityFilter)
              .map(({ topicForFilters, topic }) => (
                <button
                  className={
                    currentFilter === topicForFilters
                      ? "filter-btn filter-active"
                      : "filter-btn"
                  }
                  key={topic}
                  data-filter={topicForFilters}
                  onClick={() => action(topicForFilters, topic)}
                >
                  {topic}
                </button>
              ))}
          </>
        )}
      </div>
      <button
        className="tags__filter--btn-slide btn--forward"
        onClick={() => handleSlide(element, "right", 15, 500, 15)}
        aria-label="Фильтры вперед"
      >
        <i className="fal fa-chevron-right"></i>
      </button>
    </section>
  );
}

export default Tags;
